import { cmsRepository } from '~/repository/cmsRepository'
import type { WidgetItem, ListItem } from '~/types/ProDuctList.d.ts'

interface DescriptionBlock {
  contentDescriptionEn: string
  contentDescriptionTh: string
  url: string[]
}

export const usePageDescription = async (
  pageKey: 'Devices' | 'Collabs' | 'Products' | 'Styles'
) => {
  const route = useRoute()
  const { $serverApi } = useNuxtApp()
  const cmsRepo = cmsRepository($serverApi)
  const pageKeyType = pageKey
    ? pageKey.charAt(0).toUpperCase() + pageKey.slice(1)
    : ''

  const { data: pageData } = await useAsyncData(
    `page-navigation-${pageKeyType}`,
    async () => {
      return await cmsRepo.getWidget('navigation')
    }
  )

  //   const targetPath = `/${pageKey}`
  const widgetItem = pageData.value?.data.data.items[0].find(
    (e: WidgetItem) => e.titleEn === pageKeyType
  )

  const listMenu: DescriptionBlock[] = []

  if (widgetItem) {
    widgetItem.listMenu.forEach((section: ListItem) => {
      const source = [...(section.menus ?? []), ...(section.cards ?? [])]

      source.forEach((item) => {
        const urlList: string[] = []

        if (item.footerMenuHref) urlList.push(item.footerMenuHref)
        item.items.forEach((i) => i.href && urlList.push(i.href))

        listMenu.push({
          contentDescriptionEn: item.contentDescriptionEn,
          contentDescriptionTh: item.contentDescriptionTh,
          url: urlList
        })
      })
    })
  }

  const cleanPath = route.path.replace(/^\/(th|en|fr)/, '') || '/'
  const matched = listMenu.find((e) => e.url.includes(cleanPath))

  return {
    dataPage: matched || {
      contentDescriptionEn: null,
      contentDescriptionTh: null,
      url: []
    },
    listMenu,
    pageData
  }
}
